module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm7.706 16.348l-1.434 1.368a1.046 1.046 0 0 1-1.432 0L18 15.032V23a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-8.022l-2.838 2.682a1.043 1.043 0 0 1-1.43 0l-1.434-1.368a.933.933 0 0 1 0-1.368l6.958-6.644a1.053 1.053 0 0 1 1.434 0l7.014 6.7c.396.38.396.992.002 1.368z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-circle-4.js
// module id = 1476
// module chunks = 14